export default "__VITE_ASSET__DSDLxwh1__"